import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthCtx } from "../context/AuthContext";
import bgImg from "../assets/1.png";

export default function TopNav() {
  const navigate = useNavigate();
  const { user, signOut } = React.useContext(AuthCtx);

  const linkCls = ({ isActive }) =>
    `nav-link${isActive ? " active" : ""}`;

  return (
    <header className="topnav">
      <style>{`
        .topnav {
          position: sticky; top: 0; z-index: 40;
           background-size: cover; background-position: center;
          backdrop-filter: blur(2px);
          border-bottom: 1px solid rgba(0,0,0,.08);
        }
        .nav-inner {
          max-width: 1200px; margin: 0 auto; padding: .6rem .9rem;
          display: flex; align-items: center; gap: .75rem; justify-content: space-between;
          font-family: "Merriweather", "Georgia", serif;
        }
        .brand { font-weight: 900; color: #7A133D; font-size: 1.15rem; }
        nav { display: flex; gap: .5rem; flex-wrap: wrap; }
        .nav-link {
          padding: .4rem .7rem; border-radius: .5rem; text-decoration: none; color: #1c1c1c;
          background: rgba(255,255,255,.85); border: 1px solid rgba(0,0,0,.08);
          font-weight: 700;
        }
        .nav-link.active { border-color: #D2A857; box-shadow: 0 0 0 2px rgba(210,168,87,.25) inset; }
        .right { display: flex; align-items: center; gap: .5rem; }
        .hello { font-weight: 700; color: #d956565e; text-shadow: 0 1px 1px rgba(0,0,0,.2); }
        .btn {
          border: none; border-radius: .5rem; padding: .4rem .7rem; font-weight: 800; cursor: pointer;
          background: #C62039; color: #fff;
        }
      `}</style>

      <div className="nav-inner">
        <div className="brand" onClick={() => navigate("/home")} style={{cursor:"pointer"}}>Dashboard</div>
        <nav>
          <NavLink to="/home" className={linkCls}>Home</NavLink>
          <NavLink to="/communities" className={linkCls}>Communities</NavLink>
          <NavLink to="/events" className={linkCls}>Events</NavLink>
        </nav>
        <div className="right">
          {user && <span className="hello">Hi, {user.name || "Admin"}</span>}
          {user && <button className="btn" onClick={() => { signOut(); navigate("/login"); }}>Logout</button>}
        </div>
      </div>
    </header>
  );
}
